<template>
  <div class="bg-white rounded-lg p-6 shadow-xl">
    <div class="text-left">
      <div class="text-green-600 font-semibold">{{ title }}</div>
      <div class="text-2xl text-gray-600">{{ value }}</div>
      <div class="subtitle">{{ subtitle === undefined ? "" : subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "title", "subtitle"],
};
</script>

<style>
.subtitle {
  font-size: 12px;
}
</style>